const ucfirst = str => str.charAt(0).toUpperCase() + str.slice(1);

class CalculatorTable {
	constructor(el, refs = [], options = {}) {
		this.el = el;
		this.refs = refs;
		this.options = options;
	}

	set isUpdated(updated) {
		this.el.classList.toggle('is-updated', updated);
	}

	update(response) {
		this.updateCells(response);

		this.highlightUpdate();
	}

	updateCells(response) {
		Object.keys(response).forEach((productField) => {
			this.updateCell(productField, response[productField]);
		});
	}

	updateCell(fieldName, fieldValues) {
		Object.keys(fieldValues).forEach((valueType) => {
			const refName = `${fieldName}${ucfirst(valueType)}`;
			const ref = this.refs[refName];

			if (!ref) {
				return;
			}

			const value = fieldValues[valueType] || this.options.placeholder;
			const { isPositive = false, isNegative = false } = fieldValues;

			CalculatorTable.updateCellState(ref, isPositive, isNegative);
			CalculatorTable.updateCellValue(ref, value);
		});
	}

	highlightUpdate() {
		this.isUpdated = true;

		setTimeout(() => {
			this.isUpdated = false;
		}, 500);
	}

	static updateCellState(cell, isPositive = false, isNegative = false) {
		if (!cell.classList.contains('has-indicator')) {
			return;
		}

		cell.classList.toggle('is-positive', isPositive);
		cell.classList.toggle('is-negative', isNegative);
	}

	static updateCellValue(cell, value) {
		cell.textContent = value;
	}
}

export default CalculatorTable;
